module.exports = __webpack_public_path__ + "img/fagioli-all-uccelletto.2a64d34b.png";